module.exports = __webpack_public_path__ + "static/media/yaystack-logo.88dc0b3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/design/img/yaystack-logo.svg
// module id = 421
// module chunks = 0